export default "__VITE_ASSET__Bj4SCNB5__"